import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Radio from "antd/lib/radio";
import "antd/lib/radio/style/index.js";
import { Fragment } from 'react';
import styles from './TimeSlotPicker.module.less';
import { hvDate } from '$Utils/day-utils';
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const defaultBreakpoints = [
    { breakpoint: '0:00', label: 'Morning' },
    { breakpoint: '12:00', label: 'Afternoon (12pm - 5pm)' },
    { breakpoint: '17:00', label: 'Evening (after 5pm)' }
];
const TimeSlotPicker = ({ options, timeSlotBreakpoints = defaultBreakpoints, timezone, ...props }) => {
    let timeSlotIndex = 0;
    // Function that will map over time breakpoints, and append timeSlots or
    //   no appointments available text to each section
    function timeSlotSectionBuilder(timeBreakpoint, index) {
        var _a, _b, _c, _d, _e;
        const breakpointTimeSlots = [];
        let stillHaveTimeSlotsInArray = timeSlotIndex < options.length;
        let timeSlotIsBeforeNextBreakPoint = ((_a = timeSlotBreakpoints[index + 1]) === null || _a === void 0 ? void 0 : _a.breakpoint.localeCompare((_b = options[timeSlotIndex]) === null || _b === void 0 ? void 0 : _b.starttime)) > 0;
        const isLastTimeSlot = index == timeSlotBreakpoints.length - 1;
        // conditions to check if more timeSlots need to be populated and that
        //   timeSlots should be under the given timeBreakpoint
        while (stillHaveTimeSlotsInArray &&
            (timeSlotIsBeforeNextBreakPoint || isLastTimeSlot)) {
            const timeSlot = options[timeSlotIndex];
            breakpointTimeSlots.push(_jsx(RadioButton, { value: timeSlot, className: styles['radio-child'], "data-testid": `time-slot-${timeSlot.appointmentid}`, children: ((_c = hvDate(timeSlot.utc_datetime, timezone)) === null || _c === void 0 ? void 0 : _c.hvFormat('CUSTOM', 'h:mm A')) || timeSlot.starttime }, timeSlotIndex));
            // because timeSlotIndex is incremented, we need to reassign the values
            //   That reference the timeSlotIndex
            timeSlotIndex++;
            stillHaveTimeSlotsInArray = timeSlotIndex < options.length;
            timeSlotIsBeforeNextBreakPoint =
                ((_d = timeSlotBreakpoints[index + 1]) === null || _d === void 0 ? void 0 : _d.breakpoint.localeCompare((_e = options[timeSlotIndex]) === null || _e === void 0 ? void 0 : _e.starttime)) > 0;
        }
        return (_jsxs(Fragment, { children: [_jsx("p", { className: styles['breakpoint-header'], children: timeBreakpoint.label }, index), breakpointTimeSlots.length ? (breakpointTimeSlots) : (_jsx("p", { className: styles['no-appt-message'], children: "No available times" }))] }, index));
    }
    return (_jsx(RadioGroup, { buttonStyle: "solid", ...props, className: styles['radio-group'], children: timeSlotBreakpoints.map(timeSlotSectionBuilder) }));
};
export default TimeSlotPicker;
